import { css, html, LitEntity, renderIf, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-loading';
import './import-mapping-container';
import { parseSelectedHeaders } from '../helpers/import-mapping-helpers';

class ImportMappingConstructor extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      targetGroupGenerator: { type: Function },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-surface {
        margin: 0;
      }

      .complete-mapping {
        margin-top: 2em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    return html`
      <bn-surface>
        <h2>New Mapping</h2>
        <p>Drag and drop <b>CSV Headers</b> into <b>Target Fields</b> to map CSV data to BinSentry fields</p>

        <import-mapping-container
          .availableHeaders="${this.availableHeaders}"
          .selectedHeaders="${this.selectedHeaders}"
          .targetGroups="${this.targetGroups}"
          .recordPreview="${this.recordPreview}"
          @change="${this._refreshEntity}"
        >
          ${renderIf(this.entity.getAction('add-tag'), () => html`
            <bn-action
              slot="add-tag-action"
              .href="${this.href}"
              actionname="add-tag"
              suppressheader
              suppressflash
              submittext=${this.entity.getAction('add-tag').title}
              @response="${this._refreshEntity}"
            ></bn-action>
          `)}
        </import-mapping-container>

        <h3 class="complete-mapping">Complete the Mapping</h3>
        ${renderIf(!this.entity.getAction('create-mapping'), html`
          <p>All required fields must be mapped before mapping can be created</p>
        `)}
        <bn-action
          .href="${this.href}"
          showdisabled
          actionname="create-mapping"
          suppressheader
          submittext="Create Mapping"
          @response="${this._onCreateMappingResponse}"
        ></bn-action>
      </bn-surface>
    `;
  }

  _refreshEntity(e) {
    this.href = e.detail.entity.getLink('self').href;
  }

  _onCreateMappingResponse() {
    this.dispatchEvent(new CustomEvent('created'));
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    const { availableHeaders, recordPreview } = this.entity.properties;
    this.availableHeaders = availableHeaders;
    this.recordPreview = recordPreview;
    this.selectedHeaders = parseSelectedHeaders(this.entity);
    this.targetGroups = this.targetGroupGenerator(this.entity);
  }
}

window.customElements.define('import-mapping-constructor', ImportMappingConstructor);
